import React from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { makeStyles, Theme } from '@material-ui/core';

import { Grid } from '@ha/dsl';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import SearchLocationTitle from './SearchLocationTitle';
import SearchAdvertiserLink from './SearchAdvertiserLink';
import { getIsAdvertiserSearch } from '../selectors';

const useStyles = makeStyles<Theme>(theme => ({
  ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  locationTitle: {
    marginRight: theme.spacing(1),
  },
}));

export const SearchResultsInfoBar: React.FC = () => {
  const { md } = useMediaQuery();
  const isAdvertiserSearch = useSelector(getIsAdvertiserSearch);
  const classes = useStyles();

  return (
    <Grid container justify="space-between" alignItems="center">
      <Grid item zeroMinWidth xs={12}>
        <SearchLocationTitle
          className={cx(classes.locationTitle, md && classes.ellipsis)}
        />
      </Grid>
      {isAdvertiserSearch && (
        <Grid item xs={12}>
          <SearchAdvertiserLink />
        </Grid>
      )}
    </Grid>
  );
};

export default SearchResultsInfoBar;
